import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zoho-dashboard',
  templateUrl: './zoho-dashboard.component.html',
  styleUrls: ['./zoho-dashboard.component.css']
})
export class ZohoDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
